<svg
  width="18"
  height="18"
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.63605 15.3639C4.33593 17.0639 6.59602 18 9 18C11.404 18 13.6641 17.0639 15.3639 15.3639C17.0639 13.6641 18 11.404 18 9C18 6.59602 17.0638 4.33593 15.3639 2.63605C13.6641 0.936178 11.404 0 9 0C6.59599 0 4.33593 0.936178 2.63605 2.63605C0.936178 4.33593 0 6.59599 0 9C0 11.404 0.936178 13.664 2.63605 15.3639ZM0.947368 9C0.947368 4.55977 4.55977 0.947368 9 0.947368C13.4402 0.947368 17.0526 4.55977 17.0526 9C17.0526 13.4402 13.4402 17.0526 9 17.0526C4.55977 17.0526 0.947368 13.4402 0.947368 9ZM5.92852 14.1511C6.00008 14.1908 6.07915 14.2105 6.15814 14.2105C6.24539 14.2105 6.33254 14.1864 6.40919 14.1385L13.9881 9.40165C14.1266 9.31511 14.2108 9.16323 14.2108 8.99996C14.2108 8.83669 14.1266 8.68484 13.9881 8.59828L6.40919 3.86144C6.26318 3.77016 6.07915 3.76537 5.92852 3.84882C5.77789 3.93228 5.68446 4.09094 5.68446 4.26312V13.7368C5.68446 13.909 5.77789 14.0676 5.92852 14.1511ZM6.63182 12.8822V5.11776L12.8434 8.99996L6.63182 12.8822Z"
    fill="currentColor"
  />
</svg>
